// 他のどのimportより先に評価させる必要があるため、この位置を保つこと（詳細はファイル内コメント参照）。
import "@/infrastructure/zod-config";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/presentation/App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root 要素が見つかりません");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
